import { render, staticRenderFns } from "./UsersPanel.vue?vue&type=template&id=1f71a4e5&"
import script from "./UsersPanel.vue?vue&type=script&lang=js&"
export * from "./UsersPanel.vue?vue&type=script&lang=js&"
import style0 from "./UsersPanel.vue?vue&type=style&index=0&id=1f71a4e5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports